import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ApiService } from '../../api.service';

@Component({
	selector: 'app-mail-display',
	templateUrl: './mail-display.component.html',
	styles: `
	.w-100px {
		width: 100px;
	}
	`
})
export class MailDisplayComponent implements AfterViewInit {
	@Input() mail!: any;
	@Input() hideMain: boolean = false;
	@Input() showTrail: boolean = true;
	@Input() isFirst: boolean = true;
	@Input() allowBillingLink: boolean = true;
	@Input() showReplyBtn: boolean = false;
	@Input() apptId: any = null;
	@Output() reply = new EventEmitter<any>();
	@Output() mail_html_fetched = new EventEmitter<any>();
	mailboxReadonly = true;
	@ViewChild('iframe') iframe!: ElementRef;
	style: any = {
		"width": "100%",
		"height": "100vh"
	};
	fetchingHtml = false;
	body_html: any = "";

	constructor(private toastr: ToastrService, private apiService: ApiService) {
		if (localStorage.getItem('usertype') == "Company") {
			this.mailboxReadonly = true;
		} else {
			this.mailboxReadonly = false;
		}
		this.apiService.viewportData$.subscribe((data) => {
			if (this.body_html) {
				this.writeIframe();
			}
		})
	}

	ngAfterViewInit(): void {
		if (this.mail.html_path) {
			this.fetchingHtml = true;
			this.apiService.getMailContent(this.mail.html_path).subscribe({
				next: async (data: any) => {
					this.fetchingHtml = false;
					this.body_html = await this.renderEmail(data);
					this.processDetails();
				}, error: (error) => {
					this.fetchingHtml = false;
					this.processDetails();
				}
			});
		} else {
			this.processDetails();
		}
	}

	openCopyModalTrailMail() {
		if (this.mailboxReadonly || !this.showReplyBtn) {
			navigator.clipboard.writeText(this.mail?.from_email).then(() => { }).catch(err => { });
			this.toastr.success("Email-Id copied to clipboard.", 'Success', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		} else {
			Swal.fire({
				title: this.mail.from_email,
				text: "",
				showCancelButton: true,
				showConfirmButton: true,
				confirmButtonText: 'Reply',
				cancelButtonText: 'Copy Email-Id to clipboard',
				confirmButtonColor: '#4aab4e',
				cancelButtonColor: '#3F51B5'
			}).then((result) => {
				if (result.value) {
					this.reply.emit(true);
				} else if (result.dismiss === Swal.DismissReason.cancel) {
					navigator.clipboard.writeText(this.mail.from_email).then(() => { }).catch(err => { });
					this.toastr.success("Email-Id copied to clipboard.", 'Success', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			})
		}
	}

	processDetails() {
		this.body_html = this.replaceBlockquoteWithDiv(this.body_html);
		this.mail.body_html = this.body_html;
		try {
			this.mail.toMailArr = JSON.parse(this.mail.to_email);
		} catch (error) {
			this.mail.toMailArr = [];
		}
		try {
			this.mail.ccArr = JSON.parse(this.mail.cc);
		} catch (error) {
			this.mail.ccArr = [];
		}
		try {
			if (typeof this.mail.attachment_url == "string") {
				this.mail.attachmentsArr = JSON.parse(this.mail.attachment_url);
			} else {
				this.mail.attachmentsArr = this.mail.attachment_url || [];
			}
		} catch (error) {
			this.mail.attachmentsArr = [];
		}
		this.mail.messageDate = moment.parseZone(this.mail.message_date).format("DD-MM-YYYY HH:mm");
		if (this.mail.email_status == "draft") {
			try {
				var n = this.mail["body_html"].search('<span id="mailSeparator" style="display:none;"></span>');
				if (n >= 0) {
					this.mail["draft_body"] = this.mail["body_html"].substring(0, n);
					this.mail["body_html"] = this.mail["body_html"].substring(n, this.mail["body_html"].length);
					this.body_html = this.mail["body_html"];
				} else {
					this.mail["draft_body"] = this.mail["body_html"];
				}
			} catch (err) {
				console.error(err);
			}
		}
		this.mail_html_fetched.emit(this.mail);
		this.writeIframe();
	}

	writeIframe() {
		let doc = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;
		if (doc) {
			doc.open();
			doc.write(this.body_html);
			doc.close();
		}
	}

	replaceBlockquoteWithDiv(htmlString: string): string {
		const container = document.createElement('div');
		container.innerHTML = htmlString;
		container.querySelectorAll('blockquote').forEach((el) => {
			if (el instanceof HTMLElement) {
				const div = document.createElement('div');
				Array.from(el.attributes).forEach((attr) =>
					div.setAttribute(attr.name, attr.value)
				);
				while (el.firstChild) {
					div.appendChild(el.firstChild);
				}
				el.parentNode?.replaceChild(div, el);
			}
		});
		return container.innerHTML;
	}


	resizeIframe(iframe: any) {
		try {
			var height = iframe.contentWindow.document.documentElement.scrollHeight + 'px';
			if (height == "0px") {
				height = "100vh";
			}
		} catch (error) {
			var height = "100vh";
		}
		this.style.height = height;
	}

	async renderEmail(html: string) {
		const regex = /<img.*?src="(cid:[^"]+)"[^>]*>/g;
		const matches = [...html.matchAll(regex)];
		for (const match of matches) {
			const cid = match[1];
			const data = await this.apiService.fetchImageForCid(cid);
			if (data.body) {
				const mimeType = this.getMimeTypeFromArrayBuffer(data.body);
				const blob = new Blob([data.body], { type: mimeType || 'image/png' });
				const url = URL.createObjectURL(blob);
				html = html.replace(cid, url);
			}
		}
		return html;
	}

	getMimeTypeFromArrayBuffer(buffer: ArrayBuffer): string | null {
		const arr = new Uint8Array(buffer);
		if (arr.length < 4) return null;
		const sig = arr.slice(0, 4).map((b: any) => b.toString(16).padStart(2, '0')).join('').toUpperCase();
		switch (sig) {
			case '89504E47': return 'image/png';
			case '8950047': return 'image/png';
			case '47494638': return 'image/gif';
			case '25504446': return 'application/pdf';
			case 'FFD8FFDB':
			case 'FFD8FFE0': return 'image/jpeg';
			case '504B0304': return 'application/zip';
			default: return null;
		}
	}
}
